import { IActivityBase } from '../../models/activities';
import { IAddressBase } from '../../models/address';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateVenturesProps {
  ventureId: string;
  address?: IAddressBase;
  appstoreId?: string;
  bio?: string;
  cnpj: string;
  email: string;
  name: string;
  phone?: string;
  playstoreId?: string;
  ref: string;
  useLinearOnboardFlow: boolean;
  bookingCancellationQueueDispatchCutoff: number;
}

export interface IUpdatedVenture extends IVentureBase {
  activities: IActivityBase[];
}

export const updateVenturesService = async ({
  address,
  ventureId,
  appstoreId,
  bio,
  cnpj,
  email,
  name,
  phone,
  playstoreId,
  ref,
  useLinearOnboardFlow,
  bookingCancellationQueueDispatchCutoff,
}: IUpdateVenturesProps): Promise<IUpdatedVenture> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedVenture>(
    `/ventures/${ventureId}`,
    {
      address,
      appstoreId,
      bio,
      cnpj,
      email,
      name,
      phone,
      playstoreId,
      ref,
      useLinearOnboardFlow,
      bookingCancellationQueueDispatchCutoff,
    },
  );

  return data;
};
